export const fieldLabels = {
	PLAY_COUNT_WORDS: 'Count words',
	PLAY_MAX_COUNT_WINS: 'Max count wins',
};
